require(
  [],
  () => {
    'use strict';

    const isBasicPage = document.querySelector('[data-is-basic-page]');
    let module = '';
    if (isBasicPage) {
      module = 'recommendedCommunitiesMobileBasic';
    } else {
      module = 'recommendedCommunitiesMobilePaid';
    }

    require([module]);
  }
);

define("recommendedModalHandler", function(){});

